import {
  api
} from "@/api/index.js";
import {
  store
} from "./index";
const actions = {
  async getFeedCount() {
    let res = await api.getFeedCount();
    if (!res || !res.data) return;
    store.commit("notificationCount", res.data.data);
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/actions.js